export default {    
    storageReservationDataKey : 'sonax.user.reservationData',

    storagePushTokenKey : 'sonax.user.pushInfoData'
  }